import * as d3 from "d3";
import React from "react";
import {
    AreaChartXAxis,
    AreaChartGraph,
    AreaChartYAxis,
    DemandVersusTimeLine,
    DemandVersusTimeLinePoints,
    DemandVersusTimeFill,
} from "..";

interface AreaChartProps {
    data: { periodName: string; periodNumber: number; demandCount: number }[];
    mobile: boolean;
}

export const DemandVersusTimeGraph = (props: AreaChartProps) => {
    const { data, mobile } = props;

    const d3Id = "demandGraph";

    const margin = mobile ? 12 : 50;
    const width = 600;
    const height = mobile ? 1.25 * width : 0.5 * width;

    const yMax = d3.max(data, d => {
        if (d.demandCount > 10000) {
            return Math.ceil(d.demandCount / 10000) * 10000;
        }
        if (d.demandCount > 100) {
            return Math.ceil(d.demandCount / 100) * 100;
        }
        if (d.demandCount > 10) {
            return Math.ceil(d.demandCount / 10) * 10;
        }
        return d.demandCount;
    });

    const yScale = d3
        .scaleLinear()
        .domain([0, yMax] as number[])
        .range([height - margin * 2, 0]);

    const tickValues = data.map(d => d.periodNumber);

    const xScale = d3
        .scaleLinear()
        .domain(d3.extent(data, d => d.periodNumber))
        .range([0, width - margin * 2]);

    const getMonthName = monthNumber => {
        return data.find(x => x.periodNumber === monthNumber).periodName;
    };

    return (
        <div id="container">
            <svg
                id={d3Id}
                viewBox={`0, 0, ${width + margin}, ${
                    mobile ? height + margin * 2 : height - margin
                }`}
            >
                <g transform={`translate(${margin}, ${margin / 2})`}>
                    <DemandVersusTimeFill
                        xScale={xScale}
                        yScale={yScale}
                        data={data}
                        d3Id={d3Id}
                    />
                    <AreaChartXAxis
                        height={height}
                        margin={margin}
                        xScale={xScale}
                        tickValues={tickValues}
                        tickFormat={x => getMonthName(x)}
                        mobile={mobile}
                        d3Id={d3Id}
                    />
                    <AreaChartYAxis
                        mobile={mobile}
                        yScale={yScale}
                        tickFormat={" "}
                        d3Id={d3Id}
                    />
                    <DemandVersusTimeLine
                        xScale={xScale}
                        yScale={yScale}
                        data={data}
                        mobile={mobile}
                        d3Id={d3Id}
                    />
                    <DemandVersusTimeLinePoints
                        xScale={xScale}
                        yScale={yScale}
                        data={data}
                        mobile={mobile}
                        d3Id={d3Id}
                    />
                    <AreaChartGraph
                        height={height}
                        width={width}
                        margin={margin}
                        yScale={yScale}
                        xScale={xScale}
                        tickValues={tickValues}
                        mobile={mobile}
                        yMax={yMax}
                        d3Id={d3Id}
                    />
                </g>
            </svg>
        </div>
    );
};
